<template>
    <GChart class="timeChart" type="ColumnChart" :data="chartData" :options="chartOptions" />
</template>

<script>
import { GChart } from "vue-google-charts/legacy";

export default {
    name: "TimeChart",
    components: {
        GChart
    },
    props:["timeData"],
    data() {
        return {

            chartData: this.timeData,

            // chartData: [
            //     ['Type', 'Time', { role: 'style' }],
            //     ['Given', 19.30, '#9F84AE'],
            //     ['Average', 10.49, '#AA69CE' ],
            //     ['Current', 12.40, '#9F84AE' ],
            // ],
            chartOptions: {
                title: 'Time Taken',
                titleTextStyle: {
                    fontSize: 12
                },
                chartArea: {
                    height: '80%',
                    width: '80%'
                },
                vAxis: {
                    title: 'Time (Sec)',
                    viewWindow: {
                        min: 0
                    },
                    gridlines: {
                        color: 'transparent'
                    }
                },
                hAxis: {
                    title: '',
                },
                legend: 'none',
                bar: { groupWidth: '20%' },
                                annotations: {
                    alwaysOutside: true,
                    displayAnnotations: true,
                    textStyle: {
                        fontSize: 11,
                        color: '#666666',
                        auraColor: 'none',
                        bold: false
                    },
                    stem: {
                        color: '',
                        length: 8
                    }
                }

                
            }
        }
    }
}
</script>

<style scoped>
.timeChart {
    height: 12.5rem;
    padding-bottom: 0.5rem;
}
</style>

